import { render, staticRenderFns } from "./ProductSummaryRow.vue?vue&type=template&id=6813c0da&"
import script from "./ProductSummaryRow.vue?vue&type=script&lang=js&"
export * from "./ProductSummaryRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports